import React from "react";
import { useLang } from "../i18n";
import { STEPS } from "../config/formConfig";
import { Check } from "lucide-react";

export const Stepper = ({ current }) => {
  const { lang } = useLang();
  const steps = [...STEPS, { number: 5, fr: "Pièces & Soumission", en: "Documents & Submit" }];
  return (
    <div className="w-full overflow-x-auto step-scrollbar pb-2" data-testid="stepper">
      <div className="flex items-center min-w-[640px] sm:min-w-0">
        {steps.map((s, i) => {
          const done = current > s.number;
          const active = current === s.number;
          return (
            <React.Fragment key={s.number}>
              <div className="flex flex-col items-center flex-shrink-0" data-testid={`step-indicator-${s.number}`}>
                <div
                  className={`grid place-items-center w-9 h-9 rounded-full text-sm font-bold border-2 transition-colors ${
                    done
                      ? "bg-primary border-primary text-white"
                      : active
                      ? "bg-white border-primary text-primary"
                      : "bg-white border-slate-300 text-slate-400"
                  }`}
                >
                  {done ? <Check className="w-4 h-4" /> : s.number}
                </div>
                <span
                  className={`mt-2 text-[11px] font-medium text-center max-w-[110px] leading-tight ${
                    active ? "text-primary" : "text-slate-500"
                  }`}
                >
                  {lang === "fr" ? s.fr : s.en}
                </span>
              </div>
              {i < steps.length - 1 && (
                <div className={`h-0.5 flex-1 mx-1 sm:mx-2 -mt-6 transition-colors ${done ? "bg-primary" : "bg-slate-200"}`} />
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};
